import router from '../../router';
/**
 * 专门用于处理级联结构类，服务器相应的的字段和想要的字段名字不匹配
 * 作用：将服务器相应的字段进行转化
 * 例如：{'warehouse_id: 23, warehouse_name: '测试仓库'} ==> {'id': 23, 'name': '测试仓库'}
 */
function changeColumnByRes(ObjArr, value1, name1, value2, name2) {
    var tempObjArr = [];
    for (let i = 0, len = ObjArr.length; i < len; i++) {
        var tempObj = {};
        tempObj[value2] = ObjArr[i][value1];
        tempObj[name2] = ObjArr[i][name1];
        tempObjArr.push(tempObj);
    }
    return tempObjArr;
}

/**
 * 得到一个唯一的随机数
 */
function getUniqueRandom() {
    var randomNumStr = parseInt(Math.random() * 10000).toString();
    return (Date.now().toString() + randomNumStr);
}

/**
 * 缺少token，则跳转到登陆页进行登陆
 */
function isLogin(isLogin) {
    if(!isLogin) {
        router.push({
            'name': 'login'
        });
    }
}

/**
 * 从长文本中得到指定字数的短文本
 */
function getShortText(longText, textNum) {
    var strArr = longText.split('');
    var targetStr = '';
    for(let i = 0, len = strArr.length; i < textNum; i++) {
        if(i >= len) {
            break;
        }
        targetStr += strArr[i];
    }
    return targetStr;
}

/**
 * 正则替换指定字符串
 */
function strReplace(targetStr, key, tempStr) {
    let reg = new RegExp(key, 'g');
    return targetStr.replace(reg, tempStr);
}

export default {
    changeColumnByRes,
    getUniqueRandom,
    isLogin,
    getShortText,
    strReplace
}


// WEBPACK FOOTER //
// ./src/assets/js/Tool.js